import type { ButtonProps } from '#ui/Button.tsx'
import { getSize } from '#utils/misc.ts'
import { twm } from '#utils/twm.ts'

const widths = { auto: 'auto', full: 'w-full justify-center' }
export const buttonBaseClasses =
  'button-disabled-styles button-focus-styles shrink-0 items-center'
const subtleBaseClasses =
  ' active:z-10 active:bg-base-5 hover:bg-base-5 active:shadow-outline-warn-4 selected:shadow-outline-warn-4 selected:z-10'

export type ButtonClassProps = Pick<
  ButtonProps,
  'className' | 'rounding' | 'size' | 'width' | 'theme'
> & { isSquare?: boolean }

export function getButtonClasses({
  className,
  isSquare = false,
  rounding = 'all',
  size = 'md',
  theme = 'secondary',
  width = 'auto',
}: ButtonClassProps) {
  let baseClasses = `flex gap-1.5 whitespace-nowrap ${widths[width]} ${buttonBaseClasses} ${getSize(size, rounding, isSquare)} `

  switch (theme) {
    case 'hollow': {
      baseClasses += 'hover:bg-base-5 pressed:bg-base-5'
      break
    }
    case 'subtle': {
      baseClasses += 'shadow-outline-base-6' + subtleBaseClasses
      break
    }
    case 'subtleFlag': {
      baseClasses += 'shadow-outline-flag-5 text-flag-6' + subtleBaseClasses
      break
    }
    case 'subtleWarn': {
      baseClasses += 'shadow-outline-warn-4 text-warn-4' + subtleBaseClasses
      break
    }
    case 'subtleOk': {
      baseClasses += 'shadow-outline-ok-4 text-ok-4' + subtleBaseClasses
      break
    }
    case 'primary': {
      baseClasses += 'bg-pop-2 border-pop-2 text-white hover:bg-pop-3'
      break
    }
    case 'danger': {
      baseClasses += 'bg-flag-2 border-flag-1 hover:bg-flag-3 text-white'
      break
    }
    case 'secondary': {
      baseClasses += 'bg-base-5 hover:bg-base-6 text-stone-100'
      break
    }
    // This is the blank theme, secondary is the actual default
    default: {
      return twm(buttonBaseClasses, className)
    }
  }

  return twm(baseClasses, className)
}
